import { theme } from "app/Theme";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import HourglassFullIcon from '@mui/icons-material/HourglassFull';

const LeaveStatus = ({ leaveStatus }) => {
    switch (leaveStatus) {
      case 'approved':
        return <CheckCircleIcon sx={{ color: theme.palette.success.main, fontSize: 24 }} />;
      case 'rejected':
        return <CancelIcon sx={{ color: theme.palette.error.main, fontSize: 24 }} />;
      case 'pending':
        return <HourglassFullIcon sx={{ color: theme.palette.warning.main, fontSize: 24 }} />;
      case 'cancelled':
        return <CancelIcon sx={{ color: theme.palette.cancelled.main, fontSize: 24 }} />;
      default:
        return;
    }
}

export default LeaveStatus